export default __webpack_public_path__ + "static/media/SP_Orbit_Logo_schwarz_no_date (1).a20b2b55.jpg";